import { Text } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";

interface Props {
  /** Text to display */
  text: string;

  /** Whether the text should not be translated by localize */
  shouldNotTranslate?: boolean;
}

/** Single info item of the subscription details */
export function SubscriptionInfoItem({
  text,
  shouldNotTranslate,
}: Props): JSX.Element {
  return (
    <Text
      component={shouldNotTranslate ? "var" : "div"}
      variant="bodyL"
      sx={{
        ...withEllipsis,
      }}
    >
      {text}
    </Text>
  );
}
